import FormButton from "../../components/form-button";
import TournamentItem from "./item";
import {useEffect, useState, useTransition} from "react";
import associateServices from "../../services";
import {useSelector} from "react-redux";
import Loading from "../../components/loading";
import NoData from "../../components/no-data";
import {useTranslation} from "react-i18next";

const types = ['all', 'active', 'expired'];


const Tournaments = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()
    const [hasMore, setHasMore] = useState(false)
    const [loading, setLoading] = useState(true)
    const [activeType, setActiveType] = useState('active')
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10
    })

    const [total, setTotal] = useState(0)
    const [tournaments, setTournaments] = useState([])

    useEffect(() => {

        if (activeLanguage?.key) {
            setLoading(true)
            associateServices.getTournaments({
                ...pagination,
                language: activeLanguage?.key,
                type: activeType
            }).then(res => {
                setTournaments(res?.data?.data)
                setTotal(res?.data?.total)
                setLoading(false)
                setHasMore(res?.data?.total >= pagination.page * pagination.limit)
            })
        }
    }, [activeLanguage?.key, activeType])

    const handleMore = () => {
        setPagination(prevState => ({
            ...prevState,
            page: prevState.page + 1
        }))
    }

    return (
        <div className="section section--first">


            <div className="container">

                <div className="row">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <h1 className="section__title section__title--head">{t('tournaments.title')}</h1>

                        <ul
                            className="nav nav-tabs tabs-nav"
                            id="tabs-nav"
                            role="tablist"
                        >

                            {
                                types?.map(type => (
                                    <li className="nav-item" role="presentation" key={type}>
                                        <button
                                            onClick={e => setActiveType(type)}
                                            className={`tabs-nav__btn ${activeType === type ? 'active' : ''}`}
                                            type="button">
                                            {t(`promotions.${type}`)}
                                        </button>
                                    </li>
                                ))
                            }

                        </ul>
                    </div>


                </div>

                <div className="row">
                    {
                        loading ? <Loading/> : tournaments?.length <= 0 ?
                            <NoData desc={t('tournaments.empty')}/> : tournaments?.map(tournament =>
                                <TournamentItem {...{tournament}}
                                                key={tournament.id}/>)
                    }

                </div>
                {
                    hasMore &&
                    <div className="row">
                        <div className="col-12">
                            <FormButton
                                label={t('tournaments.load-more')}
                                loading={false}
                                disabled={loading}
                                onClick={handleMore}
                            />
                        </div>
                    </div>
                }

            </div>
        </div>

    )


}

export default Tournaments
